




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { Event } from "@/api/model";
import { eventCategory } from "@/api/mock";

@Component({
  components: {}
})
export default class PatientTimelineItem extends Vue {
  @Prop({
    required: true
  })
  public event!: Event;

  get category() {
    return eventCategory(this.event.categoryId);
  }

  get eventValue() {
    return (this.event.valueJson && JSON.parse(this.event.valueJson)) || "";
  }
}
